/**
 * How long a page keeps waiting on work the server is still doing.
 *
 * Every screen that polls a job used to carry its own fixed deadline -- three
 * minutes in the transcript panel, ten in the transcribe screen, fifteen in the
 * video screen -- and all three were set against a laptop with a GPU. On the
 * production server, which decodes at about a third of real time, the shortest
 * of them expired before a one-minute clip could possibly be finished. The page
 * stopped polling, showed nothing, and the work it had given up on completed a
 * minute later with nobody watching.
 *
 * A deadline that does not know how long the work takes cannot be set
 * correctly, so this one is told. `expected_sec` comes from the server's own
 * measured speed; the floor covers the case where it has no history yet, and
 * the ceiling is there so a wedged job still eventually reports as one rather
 * than spinning until the tab is closed.
 */

/**
 * How many times the expected wait to allow before giving up. Three, because
 * the expectation is a median: half of all jobs are slower than it by
 * construction, and a queue with something ahead of it is slower again.
 */
const SLACK = 3;

/** No job is waited on for longer than this, however slow the server says. */
const CEILING_MS = 45 * 60 * 1000;

export function giveUpAfterMs(expectedSec: number | null, floorMs: number): number {
  const expectedMs = (expectedSec ?? 0) > 0 ? expectedSec! * 1000 * SLACK : 0;
  return Math.min(CEILING_MS, Math.max(floorMs, expectedMs));
}
